export const SIGNAL_EVENTS_TAB_KEY = "signal-events";
export const ASSOCIATED_CLAIMS_TAB_KEY = "associated-claims";
export const ASSOCIATED_REPAIRS_TAB_KEY = "associated-repairs";

export const SIGNAL_EVENTS_PAGE_KEY = "sigEvAn";
export const VEHICLES_PAGE_KEY = "sigEvAnVehicles";

export const SIGNAL_EVENTS_TABLE_PAGE_KEY = "sigEvAn-se-table";
